var map = {
	"./animals": [
		506,
		506
	],
	"./animals.js": [
		506,
		506
	],
	"./birds": [
		243,
		763
	],
	"./birds.js": [
		243,
		763
	],
	"./colors": [
		743,
		743
	],
	"./colors.js": [
		743,
		743
	],
	"./country": [
		41,
		41
	],
	"./country.js": [
		41,
		41
	],
	"./sports": [
		584,
		584
	],
	"./sports.js": [
		584,
		584
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 613;
module.exports = webpackAsyncContext;